import { DIRECT_MESSAGE } from "../lib/constants/actions";

export const sendDirectMessage = (data) => {
    return { type: DIRECT_MESSAGE.SEND_DIRECT_MESSAGE, payload: data }
}
export const sendDirectMessageSuccess = (data) => {
    return { type: DIRECT_MESSAGE.DIRECT_MESSAGE_SUCCESS, payload: data }
}



export const fetchDirectMessage = (data) => {
    return { type: DIRECT_MESSAGE.FETCH_DIRECT_MESSAGE, payload: data }
}
export const fetchDirectMessageSuccess = (data) => {
    return { type: DIRECT_MESSAGE.FETCH_DIRECT_MESSAGE_SUCCESS, payload: data }
}










